import React from "react";
import {
  useDelete,
  useRefresh,
  useNotify,
  useRecordContext,
} from "react-admin";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";

import { withShowIfOfflinePayment } from "../components/Payment/withShowIfOffline";

const RedButton = styled(Button)(({ theme }) => ({
  color: "red",
}));

const PaymentDeleteButton = (props) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const record = useRecordContext();

  const [deleteOne, { loading }] = useDelete(
    "payments",
    { id: record.id, previousData: record },
    {
      onSuccess: () => {
        refresh();
        notify("Payment deleted");
      },
      onFailure: () => {
        notify("Payment deletion failed", { type: "warning" });
      },
    }
  );

  const handler = React.useCallback(() => {
    if (window.confirm("Are you sure ?")) {
      deleteOne();
    }
  }, [deleteOne]);

  return (
    <RedButton disabled={loading} onClick={handler}>
      <DeleteIcon />
    </RedButton>
  );
};

export default withShowIfOfflinePayment(PaymentDeleteButton);
